import { createGlobalStyle } from "styled-components";
import { normalize } from "styled-normalize";
const GlobalStyle = createGlobalStyle`

  ${normalize};

  html{
    font-size:62.5%;
  }
  body{
    box-sizing: border-box;
    font-family: "IBM Plex Sans KR", sans-serif;
  }
`;

export default GlobalStyle;
